
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

const MyChart = ({ leads }) => {    
  const theme = useSelector((state) => state.theme.value);
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  useEffect(() => {
    const ctx = chartRef.current.getContext('2d');
    const currentMonth = new Date().getMonth();

    // Function to calculate counts by month for multiple statuses
    const getStatusCountsByMonth = (data, statuses) => {
      const monthCounts = Array(12).fill(0); // Initialize an array for 12 months
      data.forEach(leads => {
        const month = new Date(leads.lead_data.enquiry_date).getMonth();        
        if (statuses.includes(parseInt(leads.lead_status_trigger, 10))) {
          monthCounts[month]++;
        }
      });
      return monthCounts;
    };    

    // Calculate counts for total leads
    const totalLeads = getStatusCountsByMonth(leads, [0, 1, 2, 3]);

    // Calculate counts for booked and completed leads
    const bookedLeads = getStatusCountsByMonth(leads, [1, 2]);    

    const lastSixMonths = Array.from({ length: 6 }, (_, i) => {
      const monthIndex = (currentMonth - i + 12) % 12;
      return { name: months[monthIndex], index: monthIndex };
    }).reverse();

    // Dynamic colors based on theme
    const textColor = theme === 'dark' ? '#bec1cb' : '#617288';
    const gridColor = theme === 'dark' ? '#444444' : '#e0e0e0';
     
    const data = {
      labels: lastSixMonths.map(month => month.name),
      datasets: [
        {
          label: 'Total Leads ',
          data: lastSixMonths.map(month => totalLeads[month.index]),
          borderColor: '#00cfe8',
          fill: true,
          tension: 0.1,
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 7,
        },
        {
          label: 'Booked Leads ',
          data: lastSixMonths.map(month => bookedLeads[month.index]),
          fill: true,
          borderColor: 'rgba(22, 163, 74, 1)',
          tension: 0.1,
          backgroundColor: 'rgba(22, 163, 74, 0.2)',
          pointStyle: 'circle',
          pointRadius: 5,
          pointHoverRadius: 7,
        },
      ],
      
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
          labels: {
            color: textColor,
            padding: 20,
            boxWidth: 20,
          },
        },
        title: {
          display: true,
          text: 'Leads',
          font: {
            size: 20,
            weight: 'bold',
          },
          color: textColor,
         
        },
        
      },
      
      scales: {
        x: {
          display: true,
          title: {
            display: true,
            text: 'Month',
            font: {
              size: 16,
              weight: 'bold',
            },
            color: textColor,
          },
          ticks: {
            autoSkip: false,
            color: textColor,
            font: {
              size: 10,
            },
          },
          grid: {
            color: gridColor,
          },
        },
        y: {
          display: true,
          title: {
            display: true,
            text: 'No of Leads',
            font: {
              size: 16,
              weight: 'bold',
            },
            color: textColor,
          },
          ticks: {
            color: textColor,
          },
          grid: {
            color: gridColor,
          },
          suggestedMin: 0,
          suggestedMax: Math.max(...totalLeads) + 5,
        },
      },
    };

    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }
    chartInstanceRef.current = new Chart(ctx, {
      type: 'line',
      data: data,
      options: options,
    });

    return () => {
      chartInstanceRef.current.destroy();
    };
  }, [leads, theme]);

  return <canvas ref={chartRef} style={{ width: '100%', minHeight: '300px', maxHeight: '600px' }} />;
};

export default MyChart;
